import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { BottomSheet } from '../../weekly/v2/primitives/BottomSheet';
import { DedupeContent, TidyDecisions } from '../DedupeContent';
import {
  selectCertainDuplicateGroups,
  selectMergeCandidates,
  selectUnsortedItems,
} from '../../../redux/pantrySelectors';
import { useTidyActions } from '../useTidyActions';
import { usePantryToast } from '../PantryToast';
import { Paprika, PaprikaTypography } from '../../../styles/theme';

interface DedupeSheetProps {
  visible: boolean;
  onClose: () => void;
}

export function DedupeSheet({ visible, onClose }: DedupeSheetProps) {
  const certain = useSelector(selectCertainDuplicateGroups);
  const candidates = useSelector(selectMergeCandidates);
  const unsorted = useSelector(selectUnsortedItems);
  const { t } = useTranslation();
  const { flash } = usePantryToast();
  const applyDecisions = useTidyActions(flash);

  const handleConfirm = (decisions: TidyDecisions) => {
    applyDecisions(decisions);
    onClose();
  };

  if (!visible) return null;

  return (
    <BottomSheet visible={visible} onClose={onClose}>
      <View style={styles.container}>
        <Text style={styles.title}>{t('pantry.tidy.title')}</Text>
        <DedupeContent
          certain={certain}
          candidates={candidates}
          unsorted={unsorted}
          onConfirm={handleConfirm}
          onCancel={onClose}
        />
      </View>
    </BottomSheet>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Paprika.background,
    paddingBottom: 24,
    minHeight: 400,
  },
  title: {
    ...PaprikaTypography.headingMedium,
    color: Paprika.textPrimary,
    paddingHorizontal: 16,
    paddingTop: 8,
  },
});
